const Dashboard = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-semibold text-gray-800 mb-6">
        Selamat Datang di Dashboard
      </h1>
    </div>
  );
};

export default Dashboard;
